/**
 * 导航菜单
 */
import * as types from '../mutation'
import { routeMap } from '../../utils/com.js'

const state = {
    headernav: [],
    elmenu: []
}

const getters = {
    headernav: state => state.headernav,
    elmenu: state => state.elmenu
}

// 管理左侧导航
const datamentdata = [
    {
        name: '管理',
        url: '/productment',
        child: [
            {
                name: '列表',
                url: '/datament/productmgt'
            }
        ]
    }
]

// 销售管理左侧导航
const ieditordata = [
    // {
    //     name: '测试',
    //     url: '/overview',
    //     type: 'overview'
    // },
    {
        name: '分类',
        url: routeMap('/ieditor'),
        type: 'ieditor',
        child: [{
            name: '时政',
            url: routeMap('/ieditor/list?type=2'),
        },
        {
            name: '社会',
            url: routeMap('/ieditor/list?type=3'),
        },
        {
            name: '国际',
            url: routeMap('/ieditor/list?type=4'),
        },
        {
            name: '科技',
            url: routeMap('/ieditor/list?type=5'),
        },
        {
            name: '财经',
            url: routeMap('/ieditor/list?type=6'),
        },
        {
            name: '娱乐',
            url: routeMap('/ieditor/list?type=7'),
        },
        {
            name: '体育',
            url: routeMap('/ieditor/list?type=8'),
        },
        {
            name: '军事',
            url: routeMap('/ieditor/list?type=9'),
        },
        {
            name: '时尚',
            url: routeMap('/ieditor/list?type=10'),
        }]
    }
]

// 新闻端头部导航
const pressdata = [
    {
        name: '列表',
        url: routeMap('/press/list'),
        type: 'list'
    },
    {
        name: '搜索',
        url: routeMap('/press/search'),
        type: 'search'
    }
]

// 监控端头部导航
const statsdata = [
    {
        name: '新闻列表',
        url: routeMap('/stats/list'),
        type: 'list'
    },
    {
        name: '接口统计',
        url: routeMap('/stats/interface'),
        type: 'interface'
    },
    {
        name: '事件统计',
        url: routeMap('/stats/events'),
        type: 'event'
    },
    {
        name: '标签管理',
        url: routeMap('/stats/labels'),
        type: 'labels'
    }
]

const actions = {
    /**
     * 切换顶部导航
     */
    headernavSwitch({ commit }, type) {
        // console.debug("headernavSwitch> type:%o", type);

        let data
        switch (type) {
            case 'ieditor':
                // 编辑端
                // data = ieditordata
                break;
            case 'irecord':
                // 录音端
                break;
            case 'press':
                // 新闻端
                data = pressdata
                break;
            case 'audit':
                // 审核端
                break;
            case 'stats':
                // 统计端
                data = statsdata
                break;

        }

        commit(types.HEADERNAV_SWITCH, { data })
    },
    /**
     * 切换左侧菜单
     */
    elmenuSwitch({ commit }, type) {
        let data
        switch (type) {
           default:
                // 资料管理
                data = datamentdata
                break;
        }
        commit(types.ELMENU_SWITCH, { data })
    }
}

const mutations = {
    [types.HEADERNAV_SWITCH](state, { data }) {
        state.headernav = data
    },
    [types.ELMENU_SWITCH](state, { data }) {
        state.elmenu = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navmenu.js